<template>
  <div>
    <div style="margin-bottom: 1rem">
      <el-button size="mini" @click="handleAdd" type="primary">添加菜单</el-button>
      <el-button size="mini" @click="getMenuTree" icon="el-icon-refresh">刷新</el-button>
    </div>

    <el-alert
        title="拖动提示"
        type="info"
        :closable="false"
        style="margin-bottom: 15px;">
      <template slot="default">
        <div style="line-height: 1.8;">
          <i class="el-icon-info"></i> 可以通过拖动节点来调整菜单的层级和排序：
          <ul style="margin: 5px 0; padding-left: 20px;">
            <li><b>拖到节点前/后</b>：与该节点成为同级菜单（调整排序）</li>
            <li><b>拖到节点内部</b>：成为该节点的子菜单（改变分组）</li>
          </ul>
        </div>
      </template>
    </el-alert>

    <!-- 树形视图 -->
    <el-tree
        :data="treeData"
        :props="treeProps"
        default-expand-all
        node-key="id"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        @node-drop="handleDrop">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <i :class="data.icon" style="margin-right: 5px;" v-if="data.icon"></i>
          <span>{{ data.name }}</span>
          <el-tag v-if="data.hidden" size="mini" type="info" style="margin-left: 5px;">隐藏</el-tag>
          <span v-if="data.path" style="color: #999; margin-left: 10px; font-size: 12px;">{{ data.path }}</span>
        </span>
        <span>
          <el-button type="text" size="mini" @click="() => handleEdit(data)">编辑</el-button>
          <el-button type="text" size="mini" @click="() => handleAddChild(data)">添加子菜单</el-button>
          <el-button type="text" size="mini" style="color: #F56C6C;" @click="() => handleDelete(data)">删除</el-button>
        </span>
      </span>
    </el-tree>

    <!-- 添加/编辑菜单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="formRules" ref="form" label-width="120px">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input v-model="form.path" autocomplete="off" placeholder="如: /users, dashboard"></el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            <i class="el-icon-info"></i> 不填路径时可作为分组主菜单（用于菜单分组）
          </div>
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="form.icon" autocomplete="off" placeholder="如: el-icon-user">
            <template slot="prepend">
              <i :class="form.icon"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="组件路径">
          <el-input v-model="form.component" autocomplete="off" placeholder="如: views/roles/Users"></el-input>
        </el-form-item>
        <el-form-item label="父级菜单">
          <el-cascader
            v-model="form.parent_id"
            :options="menuTreeOptions"
            :props="cascaderProps"
            clearable
            placeholder="请选择父级菜单（不选则为顶级）"
            style="width: 100%;">
          </el-cascader>
        </el-form-item>
        <el-form-item label="关联权限">
          <el-cascader
              v-model="form.permission_code"
              :options="menuPermissions"
              :props="permissionCascaderProps"
              :show-all-levels="false"
              clearable
              filterable
              placeholder="请选择权限（支持搜索）"
              style="width: 100%;">
            <template slot-scope="{ node, data }">
              <span>
                <span>{{ data.name }}</span>
                <el-tag :type="getPermissionTypeTag(data.type)" size="mini" style="margin-left: 8px;">
                  {{ getPermissionTypeText(data.type) }}
                </el-tag>
              </span>
            </template>
          </el-cascader>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            <i class="el-icon-info"></i> 只显示菜单类型的权限
          </div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="是否隐藏">
          <el-switch v-model="form.hidden"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'Menus',
  data() {
    return {
      treeData: [],
      menuTreeOptions: [],
      menuPermissions: [],
      dialogFormVisible: false,
      editMode: false,
      form: {
        name: '',
        path: '',
        icon: '',
        component: '',
        parent_id: 0,
        permission_code: '',
        sort: 0,
        hidden: false
      },
      formRules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ]
      },
      treeProps: {
        children: 'children',
        label: 'name'
      },
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      },
      permissionCascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.editMode ? '编辑菜单' : '添加菜单';
    }
  },
  mounted() {
    this.getMenuTree();
    this.getMenuPermissions();
  },
  methods: {
    getMenuTree() {
      this.http.fetchGet(this.api.menu_tree).then((res) => {
        if (res.data.code === 200) {
          this.treeData = res.data.data || [];
          this.menuTreeOptions = res.data.data || [];
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getMenuPermissions() {
      // 获取权限树（所有类型）
      this.http.fetchGet(this.api.permission_tree).then((res) => {
        if (res.data.code === 200) {
          const allPermissions = res.data.data || [];
          // 筛选并保留菜单类型的权限（包括父节点）
          this.menuPermissions = this.filterMenuPermissions(allPermissions);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 递归筛选菜单类型的权限
    filterMenuPermissions(permissions) {
      const result = [];
      
      permissions.forEach(perm => {
        // 如果是菜单类型，或者有子节点包含菜单类型，则保留
        if (perm.type === 'menu' || (perm.children && perm.children.length > 0)) {
          const filteredChildren = perm.children ? this.filterMenuPermissions(perm.children) : [];
          
          // 如果是菜单类型，或者子节点中有菜单类型，则添加此节点
          if (perm.type === 'menu' || filteredChildren.length > 0) {
            result.push({
              ...perm,
              children: filteredChildren.length > 0 ? filteredChildren : undefined,
              // 如果不是菜单类型的父节点，禁用选择
              disabled: perm.type !== 'menu'
            });
          }
        }
      });
      
      return result;
    },
    handleAdd() {
      this.editMode = false;
      this.form = {
        name: '',
        path: '',
        icon: '',
        component: '',
        parent_id: 0,
        permission_code: '',
        sort: 0,
        hidden: false
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleAddChild(data) {
      this.editMode = false;
      this.form = {
        name: '',
        path: '',
        icon: '',
        component: '',
        parent_id: data.id,
        permission_code: '',
        sort: 0,
        hidden: false
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleEdit(row) {
      this.editMode = true;
      this.form = {
        id: row.id,
        name: row.name,
        path: row.path,
        icon: row.icon,
        component: row.component,
        parent_id: row.parent_id || 0,
        permission_code: row.permission_code,
        sort: row.sort || 0,
        hidden: row.hidden || false
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editMode) {
            // 更新菜单
            this.http.fetchPut(this.api.menu_update + '/' + this.form.id, this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('更新成功');
                this.dialogFormVisible = false;
                this.getMenuTree();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('更新失败');
            });
          } else {
            // 创建菜单
            this.http.fetchPost(this.api.menu_create, this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('添加成功');
                this.dialogFormVisible = false;
                this.getMenuTree();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('添加失败');
            });
          }
        }
      });
    },
    handleDelete(row) {
      this.$confirm(`确定要删除菜单 ${row.name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.fetchDel(this.api.menu_delete + '/' + row.id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            this.getMenuTree();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    // 允许拖动
    allowDrag() {
      // 所有菜单都可以拖动
      return true;
    },
    // 允许放置
    allowDrop() {
      // 所有菜单都可以互相拖动和嵌套
      return true;
    },
    // 拖动结束后的处理
    handleDrop(draggingNode, dropNode, dropType) {
      const dragData = draggingNode.data;
      let newParentId = 0;
      let newSort = 0;
      
      if (dropType === 'inner') {
        // 拖动到节点内部，成为其子菜单
        newParentId = dropNode.data.id;
        
        // 计算新的排序值（放在子菜单列表最后）
        if (dropNode.data.children && dropNode.data.children.length > 0) {
          const maxSort = Math.max(...dropNode.data.children.map(c => c.sort || 0));
          newSort = maxSort + 1;
        } else {
          newSort = 1;
        }
      } else {
        // 拖动到节点前后，与其成为兄弟菜单
        newParentId = dropNode.data.parent_id || 0;
        
        // 计算新的排序值
        if (dropType === 'before') {
          newSort = dropNode.data.sort - 0.5;
        } else {
          newSort = dropNode.data.sort + 0.5;
        }
      }
      
      // 调用后端API更新菜单的parent_id和sort
      this.updateMenuPosition(dragData.id, newParentId, Math.round(newSort));
    },
    // 更新菜单位置
    updateMenuPosition(menuId, parentId, sort) {
      const data = {
        parent_id: parentId,
        sort: sort
      };
      
      this.http.fetchPut(this.api.menu_update + '/' + menuId, data).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('菜单位置更新成功');
          // 重新获取菜单树以确保数据同步
          this.getMenuTree();
        } else {
          this.$message.error(res.data.msg || '位置更新失败');
          // 更新失败，刷新树以恢复原状
          this.getMenuTree();
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('位置更新失败');
        // 更新失败，刷新树以恢复原状
        this.getMenuTree();
      });
    },
    // 获取权限类型标签样式
    getPermissionTypeTag(type) {
      const typeMap = {
        'menu': 'success',
        'api': 'primary',
        'button': 'warning'
      };
      return typeMap[type] || 'info';
    },
    // 获取权限类型文本
    getPermissionTypeText(type) {
      const typeMap = {
        'menu': '菜单',
        'api': 'API',
        'button': '按钮'
      };
      return typeMap[type] || type;
    }
  }
}
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

/* 树形组件样式 */
::v-deep .el-tree {
  background-color: #fff;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
}

::v-deep .el-tree-node__content {
  height: 40px;
  line-height: 40px;
  cursor: move;
}

::v-deep .el-tree-node__content:hover {
  background-color: #F5F7FA;
}

/* 拖动相关样式 */
::v-deep .el-tree-node.is-drop-inner > .el-tree-node__content {
  background-color: #409EFF;
  color: white;
}

::v-deep .el-tree-node.is-dragging {
  opacity: 0.5;
}

::v-deep .el-tree-node.is-drop-inner > .el-tree-node__content .el-tag {
  background-color: white;
  color: #409EFF;
  border-color: white;
}

/* 拖动时的占位符样式 */
::v-deep .el-tree__drop-indicator {
  height: 2px;
  background-color: #409EFF;
}

/* 隐藏没有子菜单的节点的展开图标 */
::v-deep .el-tree-node.is-leaf > .el-tree-node__content > .el-tree-node__expand-icon {
  visibility: hidden !important;
  cursor: default !important;
}

::v-deep .el-tree-node.is-leaf .el-tree-node__expand-icon {
  visibility: hidden !important;
}

::v-deep div.el-tree-node.is-leaf > div.el-tree-node__content > i.el-tree-node__expand-icon {
  display: none !important;
}
</style>

